// Order Helper Functions
// Utilities for order status validation and product management

/**
 * Order statuses that block product management operations
 */
export const BLOCKED_ORDER_STATUSES = [4, 7, 8, 10, 11];

/**
 * Check if product management is blocked for an order status
 * @param orderStatus - The current order status
 * @returns true if product management should be blocked
 */
export const isOrderProductManagementBlocked = (
    orderStatus?: number
): boolean => {
    if (!orderStatus) return false;
    return BLOCKED_ORDER_STATUSES.includes(orderStatus);
};

export const isLocationChanged = (value: unknown): boolean => {
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;
    if (typeof value === "string") {
        const normalizedValue = value.trim().toLowerCase();
        return ["true", "1", "yes"].includes(normalizedValue);
    }

    return false;
};

/**
 * Get the translation key for why an order is blocked
 * @param orderStatus - The current order status
 * @returns Translation key for the blocked reason
 */
export const getOrderBlockedReason = (orderStatus?: number): string => {
    const statusMessages: Record<number, string> = {
        4: "order_status_customer_accepted",
        7: "order_status_en_route",
        8: "order_status_completed_paid",
        10: "order_status_cancelled_by_customer",
        11: "order_status_cancelled_by_admin",
    };
    return statusMessages[orderStatus || 0] || "order_status_blocked";
};
